export default "__VITE_ASSET__CSBWL0lD__"